import { TermsContent } from "@/components/legal/TermsContent";

const TermosDeUso = () => {
  return (
    <div className="text-gray-900 px-6 py-16 max-w-5xl mx-auto">
      <TermsContent withPageTitle />
    </div>
  );
};

export default TermosDeUso;
